import { Modal as M } from "react-bootstrap";

const Modal = ({
  size = "lg",
  show,
  onHide,
  title,
  footer,
  children,
  loading,
  styles,
  variant = "",
  closeButton = true,
  backdrop = true,
  fullscreen = null,
}) => {
  return (
    <M
      fullscreen={fullscreen}
      show={show}
      onHide={onHide}
      size={size}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop={backdrop}
      style={{
        backgroundColor: "rgba(0,0,0,0.4)",
      }}
    >
      <M.Header
        closeButton={closeButton && !loading}
        style={styles ? styles.header : {}}
        className={"pt-2 pb-2 " + variant}
      >
        <M.Title id="contained-modal-title-vcenter">{!loading && title()}</M.Title>
      </M.Header>
      <M.Body>{children}</M.Body>
      {footer && <M.Footer>{!loading && footer()}</M.Footer>}
    </M>
  );
};

export default Modal;
